import _ from "lodash";

import { searchUsersByNameCallbackAsync } from "./searchUsersByNameCallbackAsync";
import { config } from "@/config";

export const debounceSearchUsersByNameCallbackAsync = _.debounce(
  searchUsersByNameCallbackAsync,
  config.constants.DEBOUNCE_TIME,
);
